export enum PassengerTypeDto {
  Customer = 0,
  Attendant = 1,
  Companion = 2,
  Child = 3,
  Unknown = 4
}